<template>
  <RightSideBar
    v-if="isOpen"
    :loading="isLoading"
    @close="isOpen = false"
    width="width:38rem"
  >
    <template v-slot:title>
      <p class="text-darkPurple font-bold">
        Renewal history - {{ displayValue(employeeInfo.fname) }} {{ displayValue(employeeInfo.lname) }}
      </p>
    </template>
    <template v-if="historyList.length">
      <div class="flex flex-col gap-3">
        <Card
          v-for="record in historyList"
          :key="record.id"
          class="w-full flex justify-between items-center gap-2 p-3"
        >
          <div
            class="w-full border-l-4 pl-3 flex justify-between items-center gap-2"
            :class="borderClass(record.status)"
          >
            <div class="flex flex-col justify-start items-start gap-1">
              <span class="text-xs text-romanSilver" v-if="record.createdAt">
                Initiated {{ formatDate(record.createdAt) }}
              </span>
              <span class="text-sm text-darkPurple font-semibold">
                {{ formatDate(record.contractEndDate, "MMM dd, yyyy") }}
                &rarr;
                {{ formatDate(record.newContractEndDate, "MMM dd, yyyy") }}
              </span>
              <span class="text-xs text-romanSilver" v-if="record.initiator">
                By {{ displayValue(record.initiator.fname) }} {{ displayValue(record.initiator.lname) }}
              </span>
            </div>
            <div class="flex items-center gap-3">
              <p class="text-center capitalize status-badge text-xs" :class="statusClass(record.status)">
                {{ formatStatus(record.status) }}
              </p>
              <Icon
                icon-name="icon-eye"
                class-name="text-darkPurple cursor-pointer"
                size="xs"
                @click.native="$emit('viewDetails', { employee: employeeInfo, request: record })"
              />
            </div>
          </div>
        </Card>
      </div>
    </template>
    <template v-else>
      <div class="flex flex-col justify-center items-center gap-5 px-10 py-20">
        <Icon icon-name="empty_agreement" size="l" style="width: 200px" />
        <p class="font-normal text-base leading-5 text-jet text-center">
          No renewal history found for this employee.
        </p>
      </div>
    </template>
    <template v-slot:footer>
      <Button
        width="7.875rem"
        class="font-semibold bg-flame text-white"
        @click="isOpen = false"
      >
        Close
      </Button>
    </template>
  </RightSideBar>
</template>

<script>
import Card from "@scelloo/cloudenly-ui/src/components/card";
import RightSideBar from "@/components/RightSideBar";
import Button from "@/components/Button";

export default {
  name: "ContractRenewalHistory",
  components: {
    Card,
    RightSideBar,
    Button,
  },
  data() {
    return {
      isLoading: true,
      isOpen: false,
      employeeInfo: {},
      historyList: [],
    };
  },
  methods: {
    displayValue(value) {
      if (value === null || value === undefined || String(value).trim() === "") return "-";
      return value;
    },
    formatDate(date, pattern = "MMMM dd, yyyy") {
      if (!date) return "-";
      return this.$DATEFORMAT(new Date(date), pattern);
    },
    formatStatus(status) {
      if (!status) return "-";
      return status.split("_").join(" ");
    },
    statusClass(status) {
      return {
        approved: status === "approved",
        pending: status === "pending",
        "not-started": status === "not_started",
        disapproved: status === "disapproved" || status === "cancelled",
      };
    },
    borderClass(status) {
      return {
        "border-blueCrayola": status === "approved",
        "border-accentSquash": status === "pending",
        "border-desire": status === "disapproved" || status === "cancelled",
        "border-romanSilver": status === "not_started" || !status,
      };
    },
    toggle(payload) {
      this.isOpen = true;
      this.isLoading = true;
      this.employeeInfo = { ...payload };
      this.historyList = [];

      this.$_getContractEmployeeDetails(payload.userId)
        .then(({ data }) => {
          this.historyList = data?.data?.contractHistory || [];
        })
        .catch((error) => {
          this.historyList = [];
          this.$toasted.error(error?.message || error, { duration: 5000 });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.status-badge {
  width: max-content;
  max-width: max-content;
  padding: 4px 8px;
  border-radius: 4px;
}
.pending {
  background: rgba(233, 147, 35, 0.08);
  color: #e99323;
}
.approved {
  background: rgba(19, 181, 106, 0.08);
  color: #13b56a;
}
.disapproved {
  background: rgba(234, 60, 83, 0.08);
  color: #ea3c53;
}
.not-started {
  background: rgba(234, 60, 83, 0.08);
  color: #ea3c53;
}
</style>
